import { Injectable } from "@angular/core";
import { WindowAccessor } from "./window.accessor";

@Injectable()
export class WindowBrowserAccessor extends WindowAccessor {
    public get(): Window | null {
      return window;
    }
}
